import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Merge } from 'lucide-react';
import { ICON_PX } from '../../ui';

/**
 * Friendly sync barrier — "Wait for all" with clear visual.
 */
function JoinNode({ data, selected }) {
  const { label, status = 'pending' } = data;
  const isSatisfied = status === 'satisfied';

  return (
    <>
      <Handle type="target" position={Position.Top} className="!bg-[var(--slate)] !w-2.5 !h-2.5 !border-2 !border-white !rounded-full" />

      <div
        className={[
          'flex items-center gap-1.5 rounded-full border-2 border-dashed px-4 py-2 transition-all',
          isSatisfied ? 'bg-green-bg border-[var(--green)]' : 'bg-slate-50 border-slate-300',
          selected ? 'ring-2 ring-aqua ring-offset-2' : '',
        ].join(' ')}
      >
        <Merge size={ICON_PX.sm} className={isSatisfied ? 'text-green-nn' : 'text-slate-400'} />
        <span className={`text-xs font-medium ${isSatisfied ? 'text-green-nn' : 'text-slate-400'}`}>
          {label || 'Wait for all'}
        </span>
      </div>

      <Handle type="source" position={Position.Bottom} className="!bg-[var(--slate)] !w-2.5 !h-2.5 !border-2 !border-white !rounded-full" />
    </>
  );
}

export default memo(JoinNode);
